// @ts-strict-ignore
import {Component, Injector} from "@angular/core";
import {
	BasicMaterialDialog,
	MatDialogDataBaseInput,
	MatDialogDataBaseOutput,
} from "../../basic-material-dialog/basic-material-dialog.directive";
import {WifiAccessPointResponse} from "@models";

export interface DialogData_ConnectWifiDialogInput extends MatDialogDataBaseInput {
	wifiNetwork: WifiAccessPointResponse;
}

export interface DialogData_ConnectWifiDialogOutput extends MatDialogDataBaseOutput {
	username: string;
	password: string;
	domain: string;
}

@Component({
	selector: "sim-connect-wifi-dialog",
	templateUrl: "./connect-wifi-dialog.component.html",
	styleUrls: ["./connect-wifi-dialog.component.scss"],
	standalone: false,
})
export class ConnectWifiDialogComponent extends BasicMaterialDialog<
	ConnectWifiDialogComponent,
	DialogData_ConnectWifiDialogInput,
	DialogData_ConnectWifiDialogOutput
> {
	password: string;
	username: string;
	domain: string;

	constructor(_injector: Injector) {
		super(_injector);
	}

	connect() {
		this.close({
			action: "ok",
			username: this.username,
			password: this.password,
			domain: this.domain,
		});
	}
}
